import React, { useEffect, useRef } from 'react';
import * as am4charts from '@amcharts/amcharts4/charts';
import styled from 'styled-components';
import { ChartData, Series, setupChart } from './am4charts';

const AxisTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
`;

const addClassLabel = (data: ChartData[]) => data.map((d) => ({ ...d, parallel: d.parallel + ' класс' }));

interface Props {
  yTitle: string;
  series: Series[];
  isClustered: boolean;
}

const Component = ({ yTitle, series, isClustered }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const chart = useRef<am4charts.XYChart>();
  const seriesWithClasses = series.map((s) => ({ ...s, data: addClassLabel(s.data) }));

  useEffect(() => {
    if (chart.current) {
      chart.current.dispose();
      chart.current = undefined;
    }
    chart.current = setupChart(ref.current!, seriesWithClasses, isClustered);

    return () => {
      chart.current!.dispose();
    };
  }, [series, isClustered]);

  return (
    <>
      <AxisTitle>{yTitle}</AxisTitle>
      <div ref={ref} style={{ width: '100%', height: '371px' }} />
    </>
  );
};

export default Component;
